import { useEffect, useState } from 'react';

// Idle nudges per the brief:
//   60s  — soft: "Pressure on — next number's waiting."
//   3min — hard: "You've stopped. Tom is still going."
//   5min — lease release: sprint paused with one-click resume.
//
// For per-user sprints there's no real lease — the 5min mark just pauses the
// runner locally. Shared / campaign sprints add a server-side lease release.

export const SOFT_NUDGE_MS = 60 * 1000;
export const HARD_NUDGE_MS = 3 * 60 * 1000;
export const PAUSE_MS = 5 * 60 * 1000;

export type NudgeLevel = 'none' | 'soft' | 'hard' | 'pause';

export function useIdleNudge(activeSince: number, enabled: boolean): NudgeLevel {
  const [level, setLevel] = useState<NudgeLevel>('none');

  useEffect(() => {
    if (!enabled) {
      setLevel('none');
      return undefined;
    }
    setLevel('none');
    const soft = setTimeout(() => setLevel('soft'), SOFT_NUDGE_MS);
    const hard = setTimeout(() => setLevel('hard'), HARD_NUDGE_MS);
    const pause = setTimeout(() => setLevel('pause'), PAUSE_MS);
    return () => {
      clearTimeout(soft);
      clearTimeout(hard);
      clearTimeout(pause);
    };
  }, [activeSince, enabled]);

  return level;
}
